module.exports = __webpack_public_path__ + "static/img/company-logo-color2.png";